<template>
    <div>
        <el-card class="profile " shadow="none">
            <div class="mt-3">
                <el-form :model="single" ref="MeetingForm" label-width="100px">
                    <el-row :gutter="20">
                        <el-col :span="16">
                            <el-form-item
                                prop="topic"
                                label="主题:"
                                :rules="[{ required: true, message: '请输入主题', trigger: 'blur' }]">
                                <el-input v-model="single.topic"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item
                                prop="password"
                                label="密码:">
                                <div class="d-flex">
                                    <el-input v-model="single.password" clearable
                                              placeholder="6位纯数字"></el-input>
                                    <el-button size="" @click="makeRandomPassword" class="ml-2"
                                               icon="el-icon-magic-stick">生成
                                    </el-button>
                                </div>
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <el-row :gutter="20" type="flex">
                        <el-col>
                            <el-form-item prop="meeting_date" label="日期:"
                                          :rules="[{ required: true, message: '请输入日期', trigger: 'blur' }]">
                                <el-date-picker class="w-100"
                                                v-model="single.meeting_date"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                :disabled="!canAdd"
                                                placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item
                                prop="meeting_time"
                                label="时间:"
                                :rules="[{ required: true, message: '请输入时间', trigger: 'blur' }]">
                                <el-time-select class="w-100"
                                                :disabled="!canAdd"
                                                placeholder="时间"
                                                v-model="single.meeting_time"
                                                :picker-options="{start: '00:00',step: '00:30',end: '23:30',}">
                                </el-time-select>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item
                                prop="duration"
                                label="时长:"
                                value-format="HH-mm-ss"
                                :rules="[{ required: true, message: '请输入时长', trigger: 'blur' }]">
                                <div class="d-flex">
                                    <el-select v-model="single.duration" placeholder="请选择" class="w-100"
                                               :disabled="!canAdd">
                                        <el-option
                                            v-for="item in duration_options"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20" type="flex" v-if="single.recurrent">
                        <el-col>
                            <el-form-item prop="end_date" label="结束日期:"
                                          :rules="[{ required: true, message: '请输入日期', trigger: 'blur' }]">
                                <el-date-picker class="w-100"
                                                v-model="single.end_date"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                :disabled="!canAdd"
                                                placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item prop="repeat" label="循环方式:">
                                <el-select class="w-100" v-model="single.repeat">
                                    <el-option label="单周循环" value="1"></el-option>
                                    <el-option label="双周循环" value="2"></el-option>
                                    <el-option label="三周循环" value="3"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item prop="weekdays" label="星期几:">
                                <el-select class="w-100" v-model="single.weekdays" multiple>
                                    <el-option label="周一" value="1"></el-option>
                                    <el-option label="周二" value="2"></el-option>
                                    <el-option label="周三" value="3"></el-option>
                                    <el-option label="周四" value="4"></el-option>
                                    <el-option label="周五" value="5"></el-option>
                                    <el-option label="周六" value="6"></el-option>
                                    <el-option label="周日" value="7"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item
                                prop="room_groups"
                                label="会议室组:">
                                <el-select v-model="single.group_id" placeholder="请选择会议室组" class="w-100">
                                    <el-option
                                        v-for="item in allRoomGroups"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item
                                prop="topic"
                                label="联席主持:"
                            >
                                <el-input v-model="single.assistants" placeholder="请输入联席主持人的jAccount账号"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="空闲时间:">
                        <meeting-freebusy ref="meeting_busy"
                                          :h323="single.option_h323"
                                          :jump="canAdd"
                                          @change='handleFreeChange'
                                          :date="single.meeting_date"
                                          :id="single.id"
                                          :group="single.group_id"
                                          :duration="single.duration"
                                          :time="single.meeting_time">
                        </meeting-freebusy>
                    </el-form-item>

                    <el-row :gutter="20">
                        <el-col :span="16">
                            <el-row>
                                <el-form-item
                                    prop="description"
                                    label="描述:">
                                    <el-input type="textarea" v-model="single.description" :rows="2"></el-input>
                                </el-form-item>
                            </el-row>
                        </el-col>
                        <el-col :span="8">
                            <el-row type="flex" style="flex-wrap: wrap">
                                <el-form-item style="margin-bottom: 0" v-if="!invisible"
                                              prop="auto_record"
                                              label="自动录制:">
                                    <el-tooltip class="item" effect="light" content="主持人启动会议后，自动在本地录制" placement="top">
                                        <el-switch v-model="single.auto_record"
                                                   :active-value="1"
                                                   :inactive-value="0"
                                        ></el-switch>
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item style="margin-bottom: 0"
                                              prop="waiting_room"
                                              label="等候室:"
                                              >
                                    <el-tooltip class="item" effect="light" content="参会者默认进入会议等候室"
                                                placement="top">
                                        <el-switch v-model="single.waiting_room"
                                                   @change="single.option_jbh = single.waiting_room?0:single.option_jbh"
                                                   :active-value="1"
                                                   :inactive-value="0">
                                        </el-switch>
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item style="margin-bottom: 0"
                                              prop="option_jbh"
                                              label="提前参会:">
                                    <el-tooltip class="item" effect="light" content="在主持人之前加入会议" placement="top">
                                        <el-switch v-model="single.option_jbh"
                                                   @change="single.waiting_room = single.option_jbh?0:single.waiting_room"
                                                   active-value="1"
                                                   inactive-value="0">
                                        </el-switch>
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item style="margin-bottom: 0;display: none;"
                                              prop="option_mute"
                                              label="静音入会:">
                                    <el-tooltip class="item" effect="light" content="参会者进入会议后默认静音" placement="top">
                                        <el-switch v-model="single.option_mute"
                                                   active-value="1"
                                                   inactive-value="0">
                                        </el-switch>
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item style="margin-bottom: 0"
                                              prop="option_interpreter"
                                              label="开启同传:">
                                    <el-tooltip class="item" effect="light" content="激活后，开启同传。主持人入会可以设置"
                                                placement="top">
                                        <el-switch v-model="single.option_interpreter"
                                                   :disabled="single && single.id && isTencentMeeting"
                                                   active-value="1"
                                                   inactive-value="0">
                                        </el-switch>
                                    </el-tooltip>
                                </el-form-item>
                                <el-form-item style="margin-bottom: 0" v-if="isTencentMeeting"
                                              prop="option_live"
                                              label="开启直播:">
                                    <el-tooltip class="item" effect="light" content="激活后，创建直播链接"
                                                placement="top">
                                        <el-switch v-model="single.option_live"
                                                   active-value="1"
                                                   inactive-value="0">
                                        </el-switch>
                                    </el-tooltip>
                                </el-form-item>
                            </el-row>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <el-row>
                <div class="line"></div>
                <div style="display: flex; align-items: center;justify-content: space-between;">
                    <div>
                        <el-button :loading="is_loading" class="mt-3 ml-2" type="primary" @click="onSubmit">
                            提交申请
                        </el-button>
                        <el-button :loading="is_loading" class="mt-3" type="default" @click="$router.replace('/my-meeting')">
                            返回我的会议
                        </el-button>
                    </div>
                </div>
            </el-row>
        </el-card>
        <address-book-picker :edit_mode="address_book_visible" :address_book="emails" @cancel="handleCancel"
                             @success="handleSuccess">
        </address-book-picker>
    </div>
</template>

<script>
import MeetingFreebusy from "@/components/Meeting-FreeBusy";
import AddressBookPicker from "@/components/address-book-picker";
import editMixin from "@/common/mixins/front-edit-mixin";

export default {
    name: "edit",
    mixins: [editMixin],
    components: { AddressBookPicker, MeetingFreebusy},
    methods: {
        onSubmit() {
            let vm = this;
            vm.is_loading = true;
            vm.single.attendees = JSON.stringify(vm.emails);
            vm.$api('Meeting.Edit', Object.assign({}, vm.single, {ask: 1}), true).then((res) => {
                if (res.data.data === 'CONFIRM') { // 确认后再次调用
                    vm.is_loading = false;
                    vm.$affirm('此次操作将会变更会议号码，请确定是否继续?').then(() => {
                        vm.is_loading = true;
                        vm.$api('Meeting.Edit', vm.single, true).then(() => {
                            vm.is_loading = false;
                            const ret = res.data.data;
                            this.afterSubmit(ret);
                        }).catch(() => {
                            vm.is_loading = false;
                            vm.$refs['meeting_busy'].queryBF();
                        });
                    });
                } else {
                    vm.is_loading = false;
                    const ret = res.data.data;
                    this.afterSubmit(ret);
                }
            }).catch(() => {
                vm.is_loading = false;
                vm.$refs['meeting_busy'].queryBF();
            });
        },
        afterSubmit(ret) {
            const vm = this;
            if (ret.message === "CREATED" || ret.message === "UPDATED") {
                this.$confirm("您的会议已经" + (ret.message === "CREATED" ? "创建" : "更新") + "，是否使用会议通知服务邀请参会者？", '', {
                    confirmButtonText: '邀请参会者',
                    cancelButtonText: '关闭',
                    type: 'warning'
                }).then(() => {
                    window.open(ret.data, "_blank");
                    vm.$router.push(this.$organization.home_page);
                }).catch(() => {
                    vm.$router.push(this.$organization.home_page);
                });

            } else {
                this.$alert('"您申请的会议需要管理员审批，审批完成后您将受到邮件通知。"', '', {
                    confirmButtonText: '关闭',
                    callback: () => {
                        vm.$router.push(this.$organization.home_page);
                    }
                });
            }

        }
    }
}
</script>

<style lang="scss">
.date-time-reminder {

    font-size: 13px;
    color: #0288D1;
    text-align: right;
}

.meeting-time-reminder {
    color: #0288D1;
    font-size: 13px;
    position: absolute;
    right: 10px;
    bottom: 5px;
}

.el-button.appendix {
    height: 28px;
    margin-top: 5px;
}
</style>
